// Drag n Drop
var isAdvancedUpload = function() {
	var div = document.createElement('div');
	return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
}();
if ( isAdvancedUpload ) {
  Drupal.behaviors.sw_dnd = {
    attach: function( context, settings ) {
      $('.input-file').once('sw-file-drop').each(function() {
        var dd = new DragDrop ( $(this) );
      });
    }
	};

	// Prevent default Drop
	/*window.addEventListener("dragover",function(e){
		if ( !$(e.target).is('input[type="file"]')) {
			e = e || event;
			e.preventDefault();
		}
	},false);
	window.addEventListener("drag",function(e){
		e = e || event;
		e.preventDefault();
	},false);
	window.addEventListener("dragstart",function(e){
		e = e || event;
		e.preventDefault();
	},false);
	window.addEventListener("drop",function(e){
		if ( !$(e.target).is('input[type="file"]')) {
			e = e || event;
			e.preventDefault();
		}
	},false);*/
}

var DragDrop = function( $wrap ) {
	var _this = this;

	this.$wrap = $wrap;

	this.$hint = $('<div class="file-drop-hint js-file-drop-hint"></div>');
	this.$wrap.append(this.$hint);
	this.$input = this.$wrap.find('.js-file-drop-input');
	this.$form = this.$input.closest('form');
	this.hint_visible = false;
	this.hint_visible_next = false;


	$(document).on('dragover dragenter', function( e ) {
		_this.hint_show();
	});
	$(document).on('dragleave dragend drop', function( e ) {
		_this.hint_hide();
	});
	this.$wrap.on('dragover dragenter', function( e ) {
		_this.$wrap.addClass('js-drop-hover');
	});
	this.$wrap.on('dragleave dragend drop', function( e ) {
		_this.$wrap.removeClass('js-drop-hover');
	});

	/*this.$wrap.on('drop', function( e ) {
		_this.on_drop(e);
	});*/

	this.$wrap.addClass('js-file-drop-processed');
};

DragDrop.prototype.on_drop = function(e) {
	var _this = this;
	var files = e.originalEvent.dataTransfer.files;
	// Using Ajaxify.js
	if ( files.length ) {
		ajax.ajax_submit(this.$form, null, function( form_data ) {
			$.each(files, function( i, file ) {
				form_data.append(_this.$input.attr('name'), file);
			});
		});
	}
};

DragDrop.prototype.hint_show = function() {
	this.hint_visible_next = true;
	this.hint_animate();
};
DragDrop.prototype.hint_hide = function() {
	var _this = this;
	this.hint_visible_next = false;
	setTimeout(function() {
		_this.hint_animate();
	},50);
};
DragDrop.prototype.hint_animate = function() {
	var _this = this;
	if ( this.hint_visible_next === this.hint_visible ) {
		return;
	}
	if ( this.hint_visible_next ) {
		_this.hint_visible = true;
		this.$hint.stop().show().animate({
			opacity: 1
		},{
			duration: 200,
			complete: function() {
				_this.hint_animate();
			}
		});
	} else {
		_this.hint_visible = false;
		this.$hint.stop().animate({
			opacity: 0
		},{
			duration: 200,
			complete: function () {
				_this.$hint.hide();
				_this.hint_animate();
			}
		});
	}
};
